import {
  Stack,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react'

import theme from '../../../../../Config/theme'

const FilterAmount = ({ state }) => {
  const { amountMin, setAmountMin, amountMax, setAmountMax } = state

  return (
    <Stack direction={'column'}>
      <Stack direction={'row'} align={'center'}>
        <InputGroup>
          <InputLeftElement children={'$'} />
          <Input
            type={'number'}
            placeholder={'min'}
            focusBorderColor={theme.default.defaultColor}
            value={amountMin}
            onChange={(e) => setAmountMin(e.target.value)}
          />
        </InputGroup>
        <Text>to</Text>
        <InputGroup>
          <InputLeftElement children={'$'} />
          <Input
            type={'number'}
            placeholder={'max'}
            focusBorderColor={theme.default.defaultColor}
            value={amountMax}
            onChange={(e) => setAmountMax(e.target.value)}
          />
        </InputGroup>
      </Stack>
    </Stack>
  )
}

export default FilterAmount